<template>
  <table>
    <thead>
      <tr>
        <th>{{ $t('common.status.status_label') }}</th>
        <th class="monitoringAlignRight">{{ $t('common.only_number') }}</th>
        <th class="monitoringAlignRight">{{ $t('common.amnt') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="status in tableData" @click="filterSendBox(status.redirectionParameter)" class="boxRequest" v-if="showOnThisService(status.service)">
        <td style="padding-right:0px;">
          <i class="icon icon-monitoring-table" :class="status.icon"></i> {{ $t(status.label) }}
        </td>
        <td class="monitoringAlignRight" :id="status.id">{{commonfunctions.parseFloatOrInt(statusValues(status.dataAccessParameter).number)}}</td>
        <td class="monitoringAlignRight">{{commonfunctions.parseFloatOrInt(statusValues(status.dataAccessParameter).amount)}} €</td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import monitoringTableData from '@/components/monitoringTable/data/monitoringTableData.json'
/** TLV 13/03/2020
* Component qui gère le tableau de monitoring du dashboard et de la page "Monitoring"
* @param La propriété "filterSendBox" correspond à la fonction de filtrage, qui
*         n'est pas la même entre le dashboard et la page de monitoring (sur le
*         dashboard, tout est monitoré sur le dernier mois)
*/
export default {
  props: ['filterSendBox', 'role'],
  data () {
    return {
      commonfunctions: this.$engine.common.functions,
      pilotageInfo: this.$engine.dashboard.model,
      tableData: monitoringTableData.monitoringTable
    }
  },
  mounted () {
    console.log(this.pilotageInfo)
  },
  methods: {
    /** @author TLV 13/03/2020
    * @brief Fonction qui retourne le nombre de demandes et le montant correspondants
    * au status de la ligne courante
    */
    statusValues (statusId) {
      /* IRY 04/2020 Ajout et prise en compte du props 'role' */
      let monthlyData = {}
      if (this.role === 'creditor') {
        monthlyData = this.pilotageInfo.dataAsCreditor.month[statusId]
      } else if (this.role === 'debtor') {
        monthlyData = this.pilotageInfo.dataAsDebtor.month[statusId]
      }
      let dataNumber = 0
      let dataAmount = 0
      if (monthlyData != null) {
        dataNumber = monthlyData.number
        dataAmount = monthlyData.amount
      }
      return {
        number: dataNumber,
        amount: dataAmount
      }
    },
    /** @author TLV 13/03/2020
    * @brief Fonction qui, en fonction de la disponibilité pour le service indiquée dans le .json,
    *     affiche la ligne du tableau si ça passe par rapport au service actuel
    *     (soit serviceIndication vaut "all", soit serviceIndication retourne un
    *     tableau avec les identifiants de service compatibles)
    */
    showOnThisService (serviceIndication) {
      return this.commonfunctions.showOnThisService(serviceIndication, this.$engine.user.currentService.id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// monitoringTable.vue?290f6755